module.exports = __webpack_public_path__ + "static/media/404.ade3a19e.svg";